/**
 * 特集タグ優先順位マッピング
 * このISSUEのコメントhttps://github.com/linkbal/mj-issues/issues/243#issuecomment-2948258497 の優先順位リストに基づく
 * CSVファイル docs/feature_tags_20250523.csv からIDを特定：https://github.com/linkbal/mj-issues/issues/243#issuecomment-2903726811
 */

// 優先順位マッピング（数字が小さいほど優先度が高い）
// priorityの属性はなくもよいが、順位を明示的に示すために、Issueのコメントと同じく追加
export const FEATURE_TAG_PRIORITIES = [
  { id: 141, name: 'ぽっちゃり女性と出会える街コン・婚活パーティー', priority: 1 },
  { id: 109, name: 'オタク婚活(オタコン・オタパ)の出会いイベント', priority: 2 },
  { id: 280, name: '自衛官（自衛隊）と結婚したい・彼氏がほしい方向けの出会いイベント', priority: 3 },
  { id: 281, name: '消防士と結婚したい・彼氏がほしい方向けの出会いイベント', priority: 4 },
  { id: 282, name: '警察官と結婚したい・彼氏がほしい方向けの出会いイベント', priority: 5 },
  { id: 283, name: 'ITエンジニアと結婚したい・彼氏がほしい方向けの出会いイベント', priority: 6 },
  { id: 284, name: '保育士と結婚したい・彼女がほしい方向けの出会いイベント', priority: 7 },
  { id: 285, name: '看護師と結婚したい・彼女がほしい方向けの出会いイベント', priority: 8 },
  { id: 312, name: 'アニメ好き（アニコン）の街コン・婚活パーティー', priority: 9 },
  { id: 14, name: 'クリスマスイベント・パーティー', priority: 10 },
  { id: 15, name: '年末年始・正月・新年イベント', priority: 11 },
  { id: 16, name: '公務員婚活・恋活パーティーイベント', priority: 12 },
  { id: 17, name: 'バレンタインイベント・パーティー', priority: 13 },
  { id: 22, name: 'GW（ゴールデンウィーク）イベント・パーティー', priority: 14 },
  { id: 34, name: 'ハロウィンイベント・パーティーイベント', priority: 15 },
  { id: 57, name: 'お花見特集', priority: 16 },
  { id: 60, name: 'BBQ(バーベキュー)出会いイベント', priority: 17 },
  { id: 145, name: '雨の日イベント', priority: 18 },
  { id: 152, name: 'ワイン会・ワインイベント・パーティー', priority: 19 },
  { id: 153, name: '朝活イベント', priority: 20 },
  { id: 217, name: '縁結び・恋結び（恋愛成就・良縁）出会いイベント', priority: 21 },
  { id: 218, name: '利き酒・飲み比べイベント', priority: 22 },
  { id: 331, name: 'スポーツがしたい！イベント', priority: 23 },
  { id: 333, name: '読書・映画好きイベント', priority: 24 },
  { id: 35, name: '婚活パーティー特集', priority: 25 },
  { id: 18, name: '恋活パーティー特集', priority: 26 },
  { id: 37, name: '趣味コン特集', priority: 27 },
  { id: 121, name: '友達作り・友達探し（社会人サークル・オフ会）', priority: 28 },
  { id: 205, name: '40代婚活パーティ―・恋愛イベント', priority: 29 },
  { id: 207, name: '30代婚活パーティー・恋愛イベント', priority: 30 },
  { id: 13, name: '40代参加OK街コン・パーティー特集', priority: 31 },
  { id: 585, name: '人数規模 2~6名', priority: 32 },
  { id: 586, name: '人数規模 4~12名', priority: 33 },
  { id: 587, name: '人数規模 10~24名', priority: 34 },
  { id: 588, name: '人数規模 20~48名', priority: 35 },
  { id: 589, name: '人数規模 40~64名', priority: 36 },
  { id: 590, name: '人数規模 60名以上', priority: 37 }
]

/**
 * 優先順位に基づいてfeature_tagを選択する関数
 * @param {Array} featureTags - feature_tagsの配列
 * @returns {Object|null} 選択されたfeature_tag、またはnull
 */
export function selectPriorityFeatureTag(featureTags) {
  if (!featureTags || featureTags.length === 0) {
    return null
  }

  // FEATURE_TAG_PRIORITIESの配列を上から順番にチェック
  for (const priorityTag of FEATURE_TAG_PRIORITIES) {
    // 1. まずnameでチェック（優先）
    const matchedByName = featureTags.find(tag => tag.name === priorityTag.name)
    if (matchedByName) {
      return matchedByName
    }

    // 2. nameでマッチしない場合、IDでチェック（タグ名は管理画面で随時に変更される可能性がるので、IDのチェックを追加）
    const matchedByID = featureTags.find(tag => tag.id === priorityTag.id)
    if (matchedByID) {
      return matchedByID
    }
  }

  // 3. 優先順位リストにない場合、idが最も若いタグを選択
  return featureTags.reduce((youngest, current) => (current.id < youngest.id ? current : youngest))
}
